import React, { FunctionComponent, ChangeEvent } from 'react';
import { Trans } from 'react-i18next';
import CurrencyComponent from '../CurrencyComponent/CurrencyComponent';
import { getCurrencySymbol, onKeyPressNumbersOnly } from '../../utils';

type Props = {
  name?: string;
  value?: number | string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur: (e: ChangeEvent<HTMLInputElement>) => void;
  id: string;
  defaultCurrency: string;
  intlId: string;
  hasValidationError?: boolean;
  min?: number;
};

const AmountInput: FunctionComponent<Props> = ({
  name,
  value,
  onChange,
  id,
  defaultCurrency,
  intlId,
  hasValidationError,
  onBlur,
  min,
}) => (
  <>
    <label
      htmlFor={id}
      className="jg-h3 jg-space-mtms jg-space-mbxs jg-display-b"
    >
      <Trans i18nKey={intlId} />
    </label>
    <div className="amount-input">
      <span className="currency-sign">
        {getCurrencySymbol(defaultCurrency)}
      </span>
      <CurrencyComponent id={id} defaultCurrency={defaultCurrency} />
      <input
        id={id}
        name={name}
        type="number"
        value={value}
        placeholder="0"
        onKeyPress={onKeyPressNumbersOnly}
        className="jg-form-control"
        onChange={onChange}
        onBlur={onBlur}
        aria-invalid={hasValidationError}
        min={min}
      />
    </div>
  </>
);

export default AmountInput;
